import { render, staticRenderFns } from "./CoLearnRequestNotification.vue?vue&type=template&id=5df18788&scoped=true&"
import script from "./CoLearnRequestNotification.vue?vue&type=script&lang=js&"
export * from "./CoLearnRequestNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df18788",
  null
  
)

export default component.exports